export default __webpack_public_path__ + "static/media/main_person.6bea596d.png";